/**********************************

  worldpantry-inventory.js   (OWYN)

  Cookie helpers + the "No Error" / stale-date self-heal + live
  product-inventory functions + the single auto-trigger that fires a zip
  lookup once the zipcode cookie is available.

  ZIP ACQUISITION: handled solely by assets/worldpantry-ipzipcode.js
  (the boss's app-proxy file -- key stays server-side). The old inline
  IPStack call and its exposed access_key have been REMOVED.

  CONSOLIDATION: assets/wp_fast_ship.js has been retired on OWYN. It
  defined the same cookie helpers (later-loading, so its copies silently
  won) plus a second IPStack call with the same exposed key, plus a
  setTimeout(geoTarget, 1000) trigger. All of that now lives here, once.
  Its <script> line has been removed from theme.liquid.

  LOAD ORDER NOTE: theme.liquid loads this file in the <head>, BEFORE
  jQuery. So nothing in this file may touch `$` at parse time -- the
  auto-trigger below waits for jQuery to exist before using it. Plain
  cookie/string helpers are jQuery-free and safe to define immediately.

  Shipping submit/display logic lives in
  snippets/worldpantry-fast-shipping-logic.liquid.

***********************************/

/* ============================================================
   CONFIG -- per-site values.
   ============================================================ */
var WP_INV = {
  endpointKey: 'WP_2026_OWYN',
  inventoryUrlSingle: 'https://shop.worldpantry.com/productinventories/owyn/productinventory.aspx',
  inventoryUrlBatch:  'https://shop.worldpantry.com/productinventories/owyn/productinventories.aspx',

  cookies: {
    zip:       'zipcode',
    fsZip:     'FastShip.ZipCode',
    receiveBy: 'FastShip.ReceiveByDateTime',
    orderBy:   'FastShip.OrderByDateTime',
    calcError: 'FastShip.FastShipCalculationError'
  },

  // Auto-trigger hooks (the forms live in the shared snippet markup).
  zipInputSelector: '.zip_input',
  formSelector:     'form.js-fs-form',

  // OWYN-specific wording -- preserved from the original file.
  outOfStockDisplay: 'Pre-order: expected ship in 3-4 weeks',
  // cta_order_by is a CLASS (not id) and starts visibility:hidden so the
  // date line never flickers in empty and multiple in-stock variants do
  // not create duplicate ids.
  inStockDisplay: "In Stock</br><div class='cta_order_by' style='visibility:hidden;'> For your area - Arrives <strong class='arrival_month'><span></span></strong></div>"
};

/**********************************
  Cookie functions  (no jQuery -- safe at parse time)
***********************************/
// Clean form -- the old version wrote a malformed "; ; path=/".
function setSessionCookie(name, value) {
  document.cookie = name + "=" + value + "; path=/";
}

function getSessionCookie(name) {
  var nameKey = name + "=";
  var cDecoded = decodeURIComponent(document.cookie);
  var cArr = cDecoded.split("; ");
  var res;
  cArr.forEach(function (val) {
    if (val.indexOf(nameKey) === 0) res = val.substring(nameKey.length);
  });
  return res;
}

// The shared logic calls deleteCookie -- neither of OWYN's old JS files
// defined it, so without this the shared logic would throw.
function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  var result = null;
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) result = decodeURIComponent(c.substring(nameEQ.length));
  }
  return result;
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value != null ? value : "") + expires + "; path=/";
}

function isValidZip(str) {
  return /^\d{5}(-\d{4})?$/.test(str || "");
}

/**********************************
  Self-heal: clear a stuck error cookie ("No Error" is the API's SUCCESS
  value, or there is no valid zip beside it), and clear legacy non-ISO
  date cookies so they re-fetch as ISO (the old "June 11" format is
  unparseable in Firefox and made the banner revert).
  No jQuery -- safe at parse time.
***********************************/
(function selfHealFastShipCookies() {
  var err = getSessionCookie(WP_INV.cookies.calcError);
  if (err) {
    var zip = getSessionCookie(WP_INV.cookies.fsZip);
    if (err === "No Error" || !isValidZip(zip)) {
      deleteCookie(WP_INV.cookies.calcError);
    }
  }
  var receiveBy = getSessionCookie(WP_INV.cookies.receiveBy);
  var orderBy = getSessionCookie(WP_INV.cookies.orderBy);
  if ((receiveBy && isNaN(new Date(receiveBy))) ||
      (orderBy && isNaN(new Date(orderBy)))) {
    deleteCookie(WP_INV.cookies.receiveBy);
    deleteCookie(WP_INV.cookies.orderBy);
  }
})();

/**********************************
  Auto-trigger (waits for jQuery, then polls for the zip cookie).

  TWO timing problems this handles:

  1) THIS FILE LOADS BEFORE jQUERY. theme.liquid puts it in the <head>
     above the jQuery <script>, so `$` does not exist at parse time.
     Calling $(document).ready() here throws "ReferenceError: $ is not
     defined" and kills everything after it. So we wait for `$` first.

  2) FIRST-VISIT RACE. worldpantry-ipzipcode.js sets the `zipcode`
     cookie via an ASYNC fetch to the app proxy, which can resolve after
     DOM ready. A single check would find no cookie and give up, so the
     date would not appear until the next visit. So we poll briefly.

  Both are bounded -- neither loop can run forever.
***********************************/
(function wpInvAutoTrigger() {
  var jqWaits = 0;
  var jqMaxWaits = 50;           // 50 * 100ms = ~5s waiting for jQuery

  function whenJQueryReady() {
    if (typeof window.jQuery === 'undefined') {
      jqWaits++;
      if (jqWaits < jqMaxWaits) {
        setTimeout(whenJQueryReady, 100);
      } else {
        console.log('worldpantry-inventory: jQuery never loaded - auto lookup skipped');
      }
      return;
    }

    window.jQuery(document).ready(function ($) {
      var attempts = 0;
      var maxAttempts = 20;      // 20 * 200ms = ~4s waiting for the zip cookie

      function tryAutoLookup() {
        // Already have a stored result? Nothing to do.
        if (getSessionCookie(WP_INV.cookies.fsZip) && getSessionCookie(WP_INV.cookies.receiveBy)) {
          console.log("FastShip data already exists, skipping auto lookup");
          return;
        }

        var zip = getCookie(WP_INV.cookies.zip);
        if (isValidZip(zip)) {
          console.log("fast geo zip " + zip);
          $(WP_INV.zipInputSelector).val(zip);
          $(WP_INV.formSelector).first().submit();
          return;                // success -- stop polling
        }

        attempts++;
        if (attempts < maxAttempts) {
          setTimeout(tryAutoLookup, 200);
        } else {
          console.log("no valid zipcode after waiting - giving up auto lookup");
        }
      }

      tryAutoLookup();
    });
  }

  whenJQueryReady();
})();

/**********************************
  Product Inventory functions

  NOTE: these reference WP_INV.inStockDisplay / WP_INV.outOfStockDisplay
  directly rather than module-level `const`s. The PDP snippet calls
  getProductInventory() while the page is still parsing, which is BEFORE
  a `const` declared lower in this file has initialized -- that threw
  "Cannot access 'InStockAlwaysSellStatusDisplay' before initialization"
  and killed the whole PDP inventory render.
***********************************/

function getProductInventoryDisplay(zip, productId, variantId, setProductInventoryStatus) {
  var postproductinventory = jQuery.post(WP_INV.inventoryUrlSingle, {
    zip: zip,
    key: WP_INV.endpointKey,
    productid: productId,
    variantid: variantId,
  });
  postproductinventory.done(function (data) {
    if (data) {
      if (data.Status == "OutOfStock") {
        data.StatusDisplay = WP_INV.outOfStockDisplay;
      }
      setProductInventoryStatus(data);
    }
  });
}

function getProductNumbers() {
  var productNumbers;
  jQuery.ajax({
    type: "GET",
    url: "/cart?view=wp-productnumbers",
    async: false,
  }).done(function (response) {
    productNumbers = JSON.parse(response);
  });
  return productNumbers;
}

function getProductInventories(productNumbers) {
  var items = [];
  var productInventories;
  for (var i = 0; i < productNumbers.length; i++) {
    var item = {};
    item["productId"] = productNumbers[i].productNumber;
    item["variantId"] = productNumbers[i].variantNumber;
    items.push(item);
  }

  if (items) {
    var shippingInfo = {};
    shippingInfo.zip = getCookie(WP_INV.cookies.zip);
    shippingInfo.items = items;
    jQuery.ajax({
      type: "POST",
      url: WP_INV.inventoryUrlBatch,
      data: {
        key: WP_INV.endpointKey,
        shippingInfo: JSON.stringify(shippingInfo),
      },
      async: false,
    }).done(function (data) {
      productInventories = data;
    });
  }
  return productInventories;
}

function showProductInventoryCartStatusDisplay(productInventories) {
  var showInventoryCartStatusDisplay = false;
  if (productInventories) {
    for (var i = 0; i < productInventories.length; i++) {
      if (productInventories[i].Status == "OutOfStock") {
        showInventoryCartStatusDisplay = true;
        break;
      }
    }
  }
  return showInventoryCartStatusDisplay;
}

/* Returns the inventory record for an item id, or null.
   The ProductId/VariantId guards prevent a crash when the API returns a
   record with a missing/empty id (previously .toUpperCase() on undefined
   threw, which killed the whole PDP inventory render). */
function getProductInventory(id, productNumbers, productInventories) {
  for (var n = 0; n < productNumbers.length; n++) {
    if (productNumbers[n].id != id) continue;

    var productNumber = productNumbers[n].productNumber;
    var variantNumber = productNumbers[n].variantNumber;

    for (var i = 0; i < productInventories.length; i++) {
      if (
        productInventories[i].ProductId &&
        productInventories[i].VariantId &&
        productInventories[i].ProductId.toUpperCase() === productNumber.toUpperCase() &&
        productInventories[i].VariantId.toUpperCase() === variantNumber.toUpperCase()
      ) {
        var inventoryStatus = productInventories[i];
        inventoryStatus.StatusDisplay =
          (inventoryStatus.Status === "OutOfStock" || inventoryStatus.Status === "AlwaysSell")
            ? WP_INV.outOfStockDisplay
            : WP_INV.inStockDisplay;
        return inventoryStatus;
      }
    }
    // Matched the variant id but found no inventory record -- return null
    // rather than falling through to undefined.
    return null;
  }
  return null;
}
